import { Link } from "react-router-dom";
import EmptyState from "../../components/common/EmptyState";
import { FiCompass } from "react-icons/fi";

export default function NotFoundPage() {
  return (
    <div className="page">
      <EmptyState icon={FiCompass} title="Page not found" text="The link may be old or mistyped." action={<Link to="/dashboard" className="btn btn-primary">Go to dashboard</Link>} />
    </div>
  );
}
